import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import MenuSelectedBorder from './MenuSelectedBorder';
import customColors from '../CustomizedUIs/Colors'
import { Box, Typography, makeStyles, useTheme } from '@material-ui/core';
import icArrow from '../assets/icons/ic_angle_down.png';
import classNames from 'classnames';

const useStyles = makeStyles((theme:any) => ({
    listItem: {
    
        padding: 25,
        paddingLeft: 20,
        position: 'relative',
        zIndex: 2,
        height: 70
    },
    listItemOpening: {
        boxShadow: '0px 4px 10px 0px rgba(0,0,0,0.2)',
    },
    listItemIcon: {
        minWidth: 0,
        marginRight: 20
    },
    listItemText: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '14px',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#ffffff',
    },
    arrowIcon: {
        width: 12
    },
    arrowIconUp: {
        width: 12,
        transform: 'rotate(180deg)'
    }
}));

export default function SubMenu({ children, name, icon, open, handleClick }: any) {
    const classes = useStyles();
    const arrowClass = open ? classes.arrowIconUp : classes.arrowIcon;
    const listItemStyles = open ? classNames(classes.listItem, classes.listItemOpening) : classes.listItem;
    const theme:any=useTheme()
    const arrayChildren = Array.isArray(children)?children:[children];
    const noneChildren = !arrayChildren || arrayChildren.filter((element: any) => element === undefined || element.props.isHidden).length === arrayChildren.length;
    // if (!children || children.filter((element: any) => element === undefined || element.props.isHidden).length === children.length) return null;
    return (
        <Box borderBottom={1} bgcolor={open?theme.menu.color.item:theme.menu.color.subItem} style={{ borderBottomColor: 'rgb(255, 255, 255,0.1)' }}>
            <Box display='flex' alignItems='center'>
                <MenuSelectedBorder opening={open} />
                <ListItem button onClick={handleClick} className={listItemStyles}>
                    <ListItemIcon className={classes.listItemIcon}>
                        {icon}
                    </ListItemIcon>
                    <ListItemText primary={<Typography className={classes.listItemText}>{name}</Typography>} />
                    {!noneChildren && <img alt='' src={icArrow} className={arrowClass} />}
                </ListItem>

            </Box>
            {
                !noneChildren &&
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {children}
                    </List>
                </Collapse>
            }
        </Box>
    );
}
